<template>
  <div class="container">
    <nav-bar @click-menu="() => showTab = true" />
    
    <div class="content">
      <router-view></router-view>
    </div>

    <transition name="fade-in-down">
      <mobile-search v-show="showTab" @close="() => showTab = false"/>
    </transition>
  </div>
</template>

<script>
import NavBar from '@/components/mobile/nav';
import mobileSearch from '@/components/mobile-search';

export default {
  data() {
    return {
      showTab: false,
    }
  },
  components: {
    NavBar,
    mobileSearch
  },

  // mounted() {
  //   localStorage.TB_APP_LANG = 'zh-CN'
  // }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgb(12, 18, 29);

  .content {
    margin-top: 72px;
    width: 100%;
    height: calc(~"100% - 72px");
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// home.vue?7d7c20d2